import './style.scss';

const Loader = () => (
	<div className="loader-container">
		<div className="lds-grid">
			<div /><div /><div />
			<div /><div /><div />
			<div /><div /><div />
		</div>
	</div>
);

export default Loader;
